export default {
  switchSmallDesktop: "1900px",
  switchTablet: "1200px",
  switchMobile: "600px",
  switchMobilePx: "600",
};
